import { useTranslation } from "react-i18next";
import { Reveal } from "./Reveal";
import { scrollTo } from "./Nav";

const IMG = "/assets/tour3d-dollhouse.jpg";

export const Tour3D = () => {
  const { t } = useTranslation();
  const features = t("tour3d.features", { returnObjects: true });

  return (
    <section id="tour-3d" className="relative border-t border-white/5 bg-[#0D0F12] px-6 py-28 lg:px-12 lg:py-40 grain" data-testid="tour3d-section">
      <div className="mx-auto grid max-w-7xl items-center gap-14 lg:grid-cols-2">
        <Reveal delay={0.1} className="lg:order-2">
          <div className="relative">
            <img
              src={IMG}
              alt={t("tour3d.imgAlt")}
              loading="lazy"
              decoding="async"
              className="w-full border border-white/10 object-cover"
              data-testid="tour3d-image"
            />
            <p className="mt-4 text-center font-code text-[10px] uppercase tracking-[0.3em] text-[#666]" data-testid="tour3d-caption">
              {t("tour3d.caption")}
            </p>
          </div>
        </Reveal>
        <Reveal className="lg:order-1">
          <p className="font-code text-[11px] uppercase tracking-[0.35em] text-[#D6705A]" data-testid="tour3d-overline">
            {t("tour3d.overline")}
          </p>
          <h2 className="mt-4 font-display text-4xl font-light leading-tight text-[#F9F8F6] sm:text-5xl lg:text-6xl" data-testid="tour3d-heading">
            {t("tour3d.h2pre")} <em className="italic text-[#D6705A]">{t("tour3d.h2em")}</em>
          </h2>
          <p className="mt-6 max-w-xl text-sm leading-relaxed text-[#A0A0A0] md:text-base" data-testid="tour3d-text">
            {t("tour3d.text")}
          </p>
          <ol className="mt-10 space-y-6">
            {features.map((f, i) => (
              <li key={f.title} className="flex gap-5" data-testid={`tour3d-feature-${i}`}>
                <span className="mt-1 shrink-0 font-code text-[11px] tracking-[0.3em] text-[#D6705A]">0{i + 1}</span>
                <div>
                  <h3 className="font-display text-xl font-light uppercase tracking-wide text-[#F9F8F6]">{f.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-[#A0A0A0]">{f.desc}</p>
                </div>
              </li>
            ))}
          </ol>
          <p className="mt-8 font-code text-[11px] uppercase tracking-[0.2em] text-[#666]" data-testid="tour3d-price-note">
            {t("tour3d.priceNote")}
          </p>
          <button
            onClick={() => scrollTo("#prenota")}
            className="mt-8 rounded-full border border-white/25 px-8 py-4 font-code text-[11px] uppercase tracking-[0.25em] text-[#F9F8F6] transition-[border-color,background-color,transform] duration-300 hover:border-[#D6705A] hover:bg-[#D6705A]/10 hover:-translate-y-1"
            data-testid="tour3d-cta"
          >
            {t("tour3d.cta")}
          </button>
        </Reveal>
      </div>
    </section>
  );
};
